import {DomainStore} from 'shared/store';
import {action, observable} from 'mobx';
import {successAlert} from 'shared/tools';
import {endpoints, types, t} from 'shared/core';
import {Goal} from 'stores/performance_goals';

class GoalListState {
  match;
  history;
  canCreateGoals;
  agent;
  store = new DomainStore();

  statusOptions = [
    { id: 'all', status: 'all', display: t('goals.All') },
    { id: 'complete', status: 'complete', display: t('goals.Complete') },
    { id: 'incomplete', status: 'incomplete', display: t('goals.Incomplete') }
  ];

  timePeriodOptions = [
    { id: 'past', status: 'past', display: t('goals.Past') },
    { id: 'current', status: 'current', display: t('goals.Current') },
    { id: 'upcoming', status: 'upcoming', display: t('goals.Upcoming') }
  ];

  @observable title;
  @observable editingGoal;
  @observable errors = {};
  @observable editGoalModalOpen = false;

  receiveProps({match, history, canCreateGoals}) {
    this.match = match;
    this.history = history;
    this.canCreateGoals = canCreateGoals;
  }

  @action setAgent(agent) {
    this.agent = agent;
  }

  @action addGoal() {
    if (this.match.params.employeeId) {
      this.history.push(`${this.match.url}/new`);
    } else {
      this.history.push('/new');
    }
  }

  @action async duplicateGoal(goal) {
    const model = await this.store.fetch(
      goal.link('duplicate'),
      types.PERFORMANCE_GOALS.GOAL
    );

    if (model) {
      this.agent.refresh();
      this.openEditGoalModal(model);
    }
  }

  @action openEditGoalModal(goal) {
    this.editingGoal = new Goal(goal);
    this.editingGoal.merge({employeeId: goal.employee.id});
    this.editGoalModalOpen = true;
  }

  @action closeEditGoalModal() {
    this.editGoalModalOpen = false;
  }

  @action updateGoal(updatedAttributes) {
    this.editingGoal.merge(updatedAttributes);
  }

  @action async saveGoal() {
    if (this.editingGoal.isNew) {
      this.createGoal();
    } else {
      this.patchGoal();
    }
  }

  @action async createGoal() {
    const {model, errors} = await this.store.post(
      endpoints.PERFORMANCE_GOALS.CREATE_FROM_DUPLICATE,
      types.PERFORMANCE_GOALS.GOAL,
      this.editingGoal
    );

    this.errors = errors;
    if (model) {
      this.history.push(`/${model.id}/view`);
      successAlert(t('goals.Goal successfully created.'));
    }
  }

  @action async patchGoal() {
    const {model, errors} = await this.store.patch(this.editingGoal);
    this.errors = errors;

    if (model) {
      this.agent.refresh();
      this.closeEditGoalModal();
      successAlert(t('goals.Goal updated'));
    }
  }

  @action async deleteGoal(goal) {
    await this.store.destroy(goal);
    this.agent.refresh();
    successAlert(t('goals.Goal deleted'));
  }

  customLinksFor(model) {
    if (!model.hasLink('duplicate')) {
      return [];
    }

    return [{
      order: 1,
      text: 'goals.Duplicate',
      action: goal => this.duplicateGoal(goal)
    }];
  }
}

export default GoalListState;
